module.exports = __webpack_public_path__ + "img/koryo.e052beeb.webp";